<button
  mat-icon-button
  [color]="hasFilters() ? 'primary' : ''"
  [matMenuTriggerFor]="partnerFilter"
  matTooltip="Brug filtre"
  [matBadge]="filterCount()"
  matBadgeSize="small"
  [matBadgeHidden]="filterCount() === 0"
  >
  <mat-icon svgIcon="filter"></mat-icon>
</button>
<mat-menu #partnerFilter="matMenu">
  @if (hasFilters()) {
    <button (click)="reset()" title="Fjern alle filtre" class="btn-icon red">
      <mat-icon svgIcon="delete"></mat-icon>
      <span>Fjern alle filtre</span>
    </button>
    <hr />
  }
  <mat-slide-toggle [checked]="isInactiveChecked()" color="primary" (change)="onInactiveToggle()">
    <span>Vis inaktive partnere</span>
  </mat-slide-toggle>
</mat-menu>
